import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { analytics } from 'app/utils/segment';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import Image from '../../../../../shared/Image/Image';
import { actions } from '../../../../../shared/attachmentsPreviewModal/actions/attachmentsPreviewModal';
import { AttachedFile } from '../AttachedFile';
import styles from './inlinedImage.module.scss';
const { attachmentsPreviewModalOpen } = actions;
export const InlinedImage = (props) => {
    const dispatch = useAppDispatch();
    const { alt, number, src, attachedFileFallback } = props;
    const [showFallback, setShowFallback] = useState(false);
    const [url, setUrl] = useState();
    const handleOnClick = () => {
        if (url) {
            dispatch(attachmentsPreviewModalOpen({ fileName: 'inlined.jpg', url }));
            analytics.conversationAttachedImageIsViewed();
        }
    };
    const handleOnLoad = (url) => {
        setUrl(url);
    };
    const handleError = (error) => {
        if (attachedFileFallback) {
            setShowFallback(true);
        }
    };
    return (_jsx(_Fragment, { children: showFallback ? (_jsx(AttachedFile, { prettyName: alt !== null && alt !== void 0 ? alt : `attached_file_${number}`, fileUrl: src })) : (_jsx("div", Object.assign({ className: styles.inlinedImage, onClick: handleOnClick }, { children: _jsx(Image, { className: styles.image, onErrorHandler: handleError, onLoad: handleOnLoad, alt: alt, src: src }) }))) }));
};
